





































































































































































































































































































































import Airport from "@/store/entities/flight/airport";
import Agency from "@/store/entities/agency";
import FlightSaleChannel from "@/store/entities/flight/flightSaleChannel";
import { Component, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import ReservationSearchInput from "@/store/entities/flight/reservation/reservationSearchInput";
import ReservationList from "@/store/entities/flight/reservation/reservationList";
import LottieAnimation from 'lottie-web-vue'
import Ajax from '../../../lib/ajax';
import TransferReservationDetailModal from "./modals/transferReservationDetailModal.vue";
@Component({
  components: { LottieAnimation,TransferReservationDetailModal },
})
export default class TransferReservationMonitor extends Vue {
  dataTable1:any={};
  dataTable2:any={};
  dataTable3:any={};
  isOpenModal: boolean = false;
  mockDataProcessContinues: any[] = [];
  headersProcessContinues: any[] = [];
  headersWaitingForPayment: any[] = [];
  mockDataWaitingForPayment: any[] = [];
  headersReturnPending: any[] = [];
  mockDataReturnPending: any[] = [];
  startDate: string = null;
  startDateMenu: boolean = false;
  dialogAgree: boolean = false;
  endDate: string = null;
  endDateMenu: boolean = false;
  waitMessage:boolean=false;
  breadcrumbsItems: any[] = [];
  active_tab: number = 0;
  checkbox: boolean = false;

  dessertHeaders: any[] = [];
  desserts: any[] = [];
  expanded: any[] = [];
  page: number | string;
    page2: number | string;
  page3: number | string;

  pageSize: number | string;
  totalCount: number | string;
  flightSaleChannels: FlightSaleChannel[] = [];
  selectedSaleChannel: FlightSaleChannel = new FlightSaleChannel();
  
  airports: Airport[] = [];
  fromAirport: Airport = new Airport();
  toAirport: Airport = new Airport();

  agencies: Agency[] = [];
  reservationSearchInput: ReservationSearchInput = new ReservationSearchInput();
  reservationList: ReservationList[] = [];
  search:string='';
  selectOrderId:string='';

  saveInvoice(item){
    console.log(item.id)
    this.selectOrderId=item.id;
    this.createInvoice();
   // this.dialogAgree=true;
  }
  async createInvoice(){
    await this.$store.dispatch({
      type: "reservation/saveInvoice",
      data: this.selectOrderId,
    }).then(x=>{
      Vue.$toast.success("Fatura Oluşturuldu");
    });
    this.dialogAgree=false;
  }

exportExcel() {
  let tables: any = [];
 

 
  this.dataTable1=this.$refs.dataTable1;

  let table1=this.dataTable1.$el;
  
  this.dataTable2=this.$refs.dataTable2;
  let table2=this.dataTable2.$el;
  this.dataTable3=this.$refs.dataTable3;
  let table3=this.dataTable3.$el;
  tables.push(table1,table2,table3);

  const names = ['Ödeme Alındı', 'Ödeme Bekleniyor', 'İptal'];
  const uri = 'data:application/vnd.ms-excel;base64,';
  const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelSheets>{worksheets}</x:ExcelSheets></x:ExcelWorkbook></xml><![endif]--></head><body>{tables}</body></html>';
  const base64 = function(s: string) { return window.btoa(unescape(encodeURIComponent(s))) };
  const format = function(s: string, c: {[key: string]: string}) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) };
  const worksheet_template = '<x:ExcelWorksheet><x:Name>{name}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions><Table>{table}</Table></x:ExcelWorksheet>';

  let worksheets = '';
  let tables_html = '';

  for (let i = 0; i < tables.length; i++) {
    const table = tables[i];
    const name = names[i] || 'Worksheet ' + (i+1);
    const ctx = {name: name, table: table.innerHTML};
    const worksheet = format(worksheet_template, ctx);
    worksheets += worksheet;
    tables_html += format(template, {tables: worksheet, worksheets: name});
  }

  const ctx1 = {worksheets: worksheets, tables: tables_html};


  window.open(uri + base64(format(template, ctx1)));
}

tableToExcel(tables: HTMLElement[], names: string[]): void {
  const uri = 'data:application/vnd.ms-excel;base64,';
  const template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelSheets>{worksheets}</x:ExcelSheets></x:ExcelWorkbook></xml><![endif]--></head><body>{tables}</body></html>';
  const base64 = function(s: string) { return window.btoa(unescape(encodeURIComponent(s))) };
  const format = function(s: string, c: {[key: string]: string}) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) };
  const worksheet_template = '<x:ExcelWorksheet><x:Name>{name}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions><Table>{table}</Table></x:ExcelWorksheet>';
  let worksheets = '';
  let tables_html = '';
  for (let i = 0; i < tables.length; i++) {
    const table = tables[i];
    const name = names[i];
    const ctx = {name: name, table: table.innerHTML};
    const worksheet = format(worksheet_template, ctx);
    worksheets += worksheet;
    tables_html += format(template, {tables: worksheet, worksheets: name});
  }

  const ctx1 = {worksheets: worksheets, tables: tables_html};
  window.open(uri + base64(format(template, ctx1)));
}
 
  get getEndDate() {
    return this.endDate
      ? moment(this.endDate).format("DD-MM-yyyy")
      : moment()
          .add(1, "days")
          .format("DD-MM-yyyy");
  }

  get getStartDate() {
    return this.startDate
      ? moment(this.startDate).format("DD-MM-yyyy")
      : moment().format("DD-MM-yyyy");
  }

  async getOrders() {

    
    this.reservationSearchInput.bookingDateStarts= moment(this.startDate).format("DD-MM-yyyy")
     this.reservationSearchInput.bookingDateEnds= moment(this.endDate).format("DD-MM-yyyy")
     this.waitMessage=true;

    await this.$store.dispatch({
      type: "reservation/getTransferOrders",
      data: this.reservationSearchInput,
    });

    this.reservationList = this.$store.state.reservation.list;
 
  
   
    this.page = this.$store.state.reservation.currentPage;
    this.pageSize = this.$store.state.reservation.pageSize;
    this.totalCount = this.$store.state.reservation.totalCount;

     this.waitMessage=false;

    
  }

  loadDetails({ item }) {}

  created() {

    this.getFlightSaleChannels();
    this.getAirports();
    this.getAgency();
    this.getOrders();

      (this.headersProcessContinues = [
        { text: "Sipariş No", value: "orderNo", },
        { text: "Sipariş Tarihi", value: "creationTime" },
        { text: "Sipariş Durumu", value: "orderStatus" },
        { text: "Müşteri", value: "customer.name" },
        { text: "Fiyat", value: "totalPrice" },
        { text: "Acenta", value: "agency.name" },
        { text: "Detay", value: "detail", align: 'center'  },
        
      ]),
      
      (this.headersWaitingForPayment = [
        { text: "Sipariş No" , value: "orderNo", },
        { text: "Sipariş Tarihi",  value: "creationTime" },
        { text: "Sipariş Durumu", value: "orderStatus"},
        { text: "Müşteri", value: "customer.name"  },
        { text: "Fiyat"  ,value: "totalPrice" },
        { text: "Acenta", value: "agency.name" },
        { text: "Detay", value: "detail", align: 'center'  },
      ]),
      (this.headersReturnPending = [
        { text: "Sipariş No", value: "orderNo" },
        { text: "Sipariş Tarihi", value: "creationTime" },
        { text: "Sipariş Durumu", value: "orderStatus" },
        { text: "Müşteri", value: "customer.name" },
        { text: "Fiyat", value: "totalPrice " },
        { text: "Acenta", value: "agency.name" },
        { text: "Detay", value: "detail", align: 'center'  },
      ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Transfer", disabled: true },
        { text: "Transfer Rezervayon Monitörü", disabled: true },
      ]);

      setTimeout(() => {
   this.active_tab=1;
}, 10); // 2000 milisaniye = 2 saniye
setTimeout(() => {
   this.active_tab=2;
}, 10); // 2000 milisaniye = 2 saniye
setTimeout(() => {
   this.active_tab=0;
}, 10); // 2000 milisaniye = 2 saniye
  }

  async getAgency() {
    await this.$store.dispatch({
      type: "agency/getAgency",
    });

    this.agencies = this.$store.state.agency.list;
  }

  async getFlightSaleChannels() {
    await this.$store.dispatch({
      type: "flightSaleChannel/getFlightSaleChannels",
      data: "{}",
    });

    this.flightSaleChannels = this.$store.state.flightSaleChannel.list;
  }

  async getAirports() {
    await this.$store.dispatch({
      type: "airport/getAirports",
      data: "{}",
    });

    this.airports = this.$store.state.airport.list;
  }

  async openModal(item) {
    await this.$store.dispatch({
      type: "reservation/getTransferOrderDetails",
      data: item.id,
    });
    this.isOpenModal = true;
  }
  closeModal() {
  
    this.isOpenModal = false;
  }

  get completedOrders() {
    return this.reservationList.filter((r) => r.orderStatus === 4);

  }

  get pendingOrders() {
    return this.reservationList.filter((r) => r.orderStatus === 3);
  }

  get cancelOrders() {
    return this.reservationList.filter((r) => r.orderStatus === 2);
  }
  get getMinEndDate() {
    return this.startDate
      ? moment(this.startDate)
          .add(2, "days")
          .toISOString()
          .slice(0, 10)
      : "";
  }

  data() {
    return {
      page: 1,
      page2: 1,
      page3: 1,
      pageCount: 0,
      pageCount2: 0,
      pageCount3: 0,

    };
  }
}
